import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class EntityMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.entityMapperError"));

        Object.setPrototypeOf(this, EntityMapperError.prototype);
    }
}